import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { Documents } from '@src/components/Documents';
import { FileUpload, useLocale } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
import styles from './UploadDocuments.module.scss';
export const UploadDocuments = ({ title, infoText, documents: initialDocuments, onChange, required, errors, uploadOnly = false, useDragAndDrop = true, btnText, }) => {
    const { t } = useLocale();
    const [documents, setDocuments] = useState(initialDocuments);
    useEffect(() => {
        onChange(documents);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents]);
    if (!title) {
        title = t('Supporting Document');
    }
    const handleUpload = (s3Key, file) => {
        const name = s3Key.split('/').pop() || '';
        setDocuments(prev => [
            ...prev,
            { name, s3Key, fileSize: file.size, date: new Date().toISOString() },
        ]);
    };
    const handleChange = (documents) => {
        setDocuments(documents);
    };
    return (_jsxs("div", { className: styles.uploadDocuments, children: [_jsx(Typography, { variant: 'label2', children: infoText }), _jsx(FileUpload, { label: required ? `${t('Upload Document')} *` : t('Upload Document'), buttonLabel: btnText, hideLabel: true, fileType: 'document', onUploaded: handleUpload, useDragAndDrop: useDragAndDrop, errors: errors }), !uploadOnly && documents.length > 0 && (_jsx("div", { className: 'mt-2', children: _jsx(Documents, { editable: true, documents: documents, onChange: handleChange }) }))] }));
};
